import { SoftwareFeaturePage } from './SoftwareFeaturePage';

export function AgencyModePage() {
  return (
    <SoftwareFeaturePage content={{
      eyebrow: 'Software — Agency Client Mode',
      title: 'Run your agency desk without the spreadsheet chaos.',
      subtitle: 'Client pipelines, branded submissions, and response tracking — built for agency recruiters.',
      description: 'GoGrabJob natively supports the agency hiring model: manage multiple clients in one workspace, share branded candidate packs, and know the moment a client has reviewed your submission.',
      heroBg: 'linear-gradient(150deg, #EEF2FF 0%, #E0E7FF 35%, #EEF2FF 65%, #EDE9FE 100%)',
      accentText: 'text-indigo-600',
      stats: [
        { value: 'Native', label: 'Agency + in-house in one product' },
        { value: 'Branded', label: 'Client submission packs' },
        { value: 'Real-time', label: 'Client review tracking' },
        { value: 'Multi-client', label: 'Pipeline separation' },
      ],
      sections: [
        {
          heading: 'Client Management',
          bullets: [
            'Separate pipeline per client — no data bleed between accounts',
            'Client contact records linked to every requisition',
            'Client-specific SLA tracking and status dashboards',
            'Invite clients to a read-only portal for shortlist review',
            'Track client response rates and time-to-feedback',
            'Activity log per client for relationship context',
          ],
        },
        {
          heading: 'Candidate Submission',
          bullets: [
            'One-click branded candidate pack generation',
            'Include AI interview clips, fit scores, and recruiter notes',
            'Shareable link — no login required for client',
            'Email open and click tracking on every submission',
            'Client feedback captured inline — approve, reject, or request more',
            'Submission history version-controlled per role',
          ],
        },
        {
          heading: 'Agency Operations',
          bullets: [
            'Multi-desk support — segment by industry, region, or division',
            'Consultant performance: submissions, placements, pipeline velocity',
            'Revenue and placement reporting per client',
            'Hot-list management — flag candidates for fast redeployment',
          ],
        },
      ],
    }} />
  );
}
